import React from "react";
import { Create, SimpleForm, TextInput } from "react-admin";
import { Typography } from "@material-ui/core";
import { getRequiredFieldErrors } from "../../utils";

export function ClassStyleCreate(props) {
  return (
    <Create {...props} mutationMode="pessimistic">
      <SimpleForm validate={(v) => getRequiredFieldErrors(v, ["name"])}>
        <Typography variant="h6">Create Class Style</Typography>
        <TextInput label="Name" source="name" fullWidth />
      </SimpleForm>
    </Create>
  );
}
